/**
 * dashboard module
 */
export default {
  'views/mainPage': () => import('@/views/mainPage/index.vue'),
  'views/tenantsDashboard': () => import('@/views/tenantsDashboard/index.vue'),
};
